import React from 'react';
import { Image, StyleSheet } from 'react-native';

import { Text } from '@/components/TextComponent';
import { Box } from '@/components/lib/components/Box';
import { ds } from '@/components/lib/design.system';

type BetrBucksSheetDescriptionProps = {
    message: string;
};

/**
 * Info sheet description showing the Betr Bucks bundle image above a headline message.
 */
export const BetrBucksSheetDescription = ({ message }: BetrBucksSheetDescriptionProps) => {
    return (
        <Box alignItems="center" justifyContent="center" paddingHorizontal="s8">
            <Image source={require('@/assets/images/betr_bucks_with_promotion.png')} style={styles.betrBucksImage} />
            <Text variant="headlineMedium" lineHeight={28} textAlign="center" color={ds.colorToken.text.primary}>
                {message}
            </Text>
        </Box>
    );
};

const styles = StyleSheet.create({
    betrBucksImage: {
        width: 80,
        height: 80,
        marginBottom: 20,
    },
});
